import { PasswordStrength } from '@/common/domain/login/PasswordStrength';
import { InjectionKey } from 'vue';

export const passwordStrengthRetrieverKey: InjectionKey<PasswordStrengthRetriever> = Symbol();

export interface PasswordStrengthRetriever {
  retrieve(password: string): PasswordStrength;
}
